import React from 'react'
import firebaseApp from './firebaseApp'
import firebase from 'firebase/app'
import logo from './assets/logo.png'
import './style/emailList.css';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import EmailIcon from '@material-ui/icons/Email';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import {deleteFilter} from "./api/gmail-api"
import {deleteBlacklist} from "./api/firestore-api"
import {deleteWhitelist} from "./api/firestore-api"
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ListItem from "@material-ui/core/ListItem";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Drawer from "@material-ui/core/Drawer";
import clsx from "clsx";
import { Link } from 'react-router-dom';
import { createFalse } from 'typescript';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
            <Box p={0}>
                {children}
            </Box>
            )}
      </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

function DisplayHeaderContent(){
    const username = firebaseApp.auth().currentUser.displayName;

    return(
      <>
        <div className="headerContent">
            <img src={logo} className="App-logo" alt="logo" /> 
            <div className="headerTitle">
                Welcome <b>{username}</b> <br/>
                <hr />
                <i>How are you today?</i>
            </div>
        </div>
    </>
    );
}

function MenuLink(){
    
    const user = firebaseApp.auth().currentUser;    

    if (user != null) {
        var username = user.displayName;
        var email = user.email;
        var photoUrl = user.photoURL;
    }

    const [open, setOpen] = React.useState(false);
    
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return(
        <>
        <div className="menu"> 
            <Toolbar>
                <IconButton
                    aria-label="menu"
                    onClick={handleDrawerOpen}
                    edge="start"
                    className={clsx(open && "menuHide")}
                >
                    <div className="material-icons menuIcon">menu</div>
                </IconButton>
            </Toolbar>
            <Drawer
                className="menuSection"
                anchor="left"
                onClose={handleDrawerClose}
                open={open}
                classes={{
                    paper: "menuLinkPaper",
                }}
            >
                <div className ="expandMenuSection" >
                    <div className="menuLinkHeader">
                        <IconButton onClick={handleDrawerClose}>
                            <MenuIcon className="menuIconStyle"/>
                        </IconButton>
                    </div>
                    <div className="displayUserInformation">
                        <div className="googleProfilePicSection">
                            <img alt="profile pic icon" src={photoUrl} className="googleProfilePic" />
                            <Link to ="/profile">
                                <div className="btnView"><p>View</p></div>
                            </Link>
                        </div>
                        <div className="loginDetails">
                            <h3 className="username">{username} </h3>
                            <h5 className="emailAddress"><i>{email}</i></h5>
                        </div>
                    </div>
                    <Divider />
                    <List className="listSection">
                        <ListItemLink className="menuLink" href="/dashboard">
                            DASHBOARD
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/securityEvents">
                            SECURITY EVENTS
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/emailList">
                            BLACKLIST / WHITELIST
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/events">
                            YOUR EVENTS
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/policy">
                            OUR POLICY
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/newUserSetup">
                            INSTALLATION
                        </ListItemLink>
                    </List>
                </div>
            </Drawer>
        </div>
        </>
    );
}

function GetEmailAddress(){
    const user = firebaseApp.auth().currentUser;    

    if (user != null) {
        var email = user.email;
    }

    const[whitelist, setWhitelist] = React.useState([])
    const[blacklist, setBlacklist] = React.useState([])


    React.useEffect(() => 
    {
        //get database
        const db = firebaseApp.firestore()

        //login document creation
        var userRef = db.collection('users').doc(email);
        userRef.get().then(function(doc)
        {
            //if user exists in our database
            if(doc.exists)
            {
                //get whitelist and blacklist from user
                db.collection('users').doc(email).onSnapshot( function(doc) 
                {
                    setWhitelist(doc.data().whitelist)
                    setBlacklist(doc.data().blacklist) 
                })
            }
        }).catch(function(error)
        {
            console.log("error is " + error);
        })                                                                              
    },[])
    return (
        // pass in current element blacklist and whitelist to DeleteUserAccount
        <DisplayListedEmailAddresses blacklist={blacklist} whitelist={whitelist} />
    );
}

// props value include blacklist and whitelist element, refer from GetEmailAddress()
function DisplayListedEmailAddresses(props){
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
      };
    
    const handleChangeIndex = (index) => {
        setValue(index);
    };

    return(
        <div className="listTableContent">
                <Tabs
                value={value}
                onChange={handleChange}
                variant="fullWidth"
                indicatorColor="primary"
                aria-label="list table content full width tabs"
                >
                    <Tab className={value === 0 ? "active" : "deactive"} label="Blacklist" {...a11yProps(0)}/>
                    <Tab className={value === 1 ? "active" : "deactive"} label="Whitelist" {...a11yProps(1)}/>
                </Tabs>
            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <div className="listEmailAddress">
                        <Table aria-label="blacklist table">
                            <TableHead>
                                <TableRow >
                                    <TableCell colSpan="2" scope="row" align="center"><b><u>Email Address</u></b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {props.blacklist.map((mail, index) => (
                                <TableRow key={mail.id}>
                                    <TableCell className="emailCol" scope="row" align="center">{mail.email}</TableCell>
                                    <TableCell className="unmarkCol" align="center">
                                        {/* pass in current element index,email, blacklist and string blacklist to DisplayUnmarkDialog  */}
                                        <DisplayUnmarkDialog index={index} email={mail.email} blacklist={props.blacklist} list={"blacklist"}/>
                                    </TableCell>   
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </div>
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    <div className="listEmailAddress">
                        <Table aria-label="whitelist table">
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan="2" scope="row" align="center"><b><u>Email Address</u></b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {props.whitelist.map((mail, index) => (
                                <TableRow key={mail.id}>
                                    <TableCell className="emailCol" scope="row" align="center">{mail.email}</TableCell>
                                    <TableCell className="unmarkCol" align="center">
                                        {/* pass in current element index, email, whitelist and string whitelist to DisplayUnmarkDialog  */}
                                        <DisplayUnmarkDialog index={index} email={mail.email} whitelist={props.whitelist} list={"whitelist"}/>
                                    </TableCell>             
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </div>
                </TabPanel>
            </SwipeableViews>
        </div>
    );
}


//prevent user from refreshing before clicking okay
var list;
var action;
var mail;
// props value include index, email, whitelist / blacklist element and string of blacklist / whitelist, refer from DisplayListedEmailAddresses()
function DisplayUnmarkDialog(props)
{
   
    //confirm open is the dialog with confirm and cancel buttons
    const [ConfirmOpen, setConfirmOpen] = React.useState(false);
    
    //used to determine the index of what the user wants to unmark
    const[currentIndex,setIndex] = React.useState(0);

    //ok open is the dialog with ok button after user clicks on confirm
    const [OkOpen, setOkOpen] = React.useState(false);

    const handleConfirmClickOpen = () => {
        setConfirmOpen(true);
    };

    const handleCmfClose = () => {
        setConfirmOpen(false);
    };

    const handleOkClose = () => {
        setOkOpen(false);
    };
    const handleOkOpen = () => {
        
        setOkOpen(true);
    };
    
    const handleUnmarkClickOpen = (index) => {
        setIndex(index);
        handleConfirmClickOpen();
    };
    const unmarkEmail = (mail , list) =>{
        const userEmail = firebase.auth().currentUser.email
        var data = 
        {
            "id": mail.id,
            "email": mail.email
        }
        if(list === "blacklist")
        {
            //remove gmail filter and firestore data
            deleteBlacklist(data, userEmail).then(
                deleteFilter(data.id).then(()=>{})
            )
        }
        else if(list === "whitelist")
        {
            //remove gmail filter and firestore data
            deleteWhitelist(data, userEmail).then(
            deleteFilter(data.id).then(()=>{})
            )
        }
    }

    if (props.list === "blacklist")
    {
        action = "Unmarked Blacklist";
        list = "blacklist";
        mail = props.blacklist[currentIndex];
    }
    else if (props.list === "whitelist")
    {
        action = "Unmarked Whitelist";
        list = "whitelist";
        mail = props.whitelist[currentIndex];
    }
    
    const handleEvent = () =>
    {
        //used for getting date n time 
        var myTimestamp = firebase.firestore.Timestamp.fromDate(new Date());
        var timeUTC = myTimestamp.toDate().toString().substring(16,31)

        //data to store in firebase
        var data = {"action": action,
        "target": props.email,
        "date": myTimestamp.toDate().toDateString(),
        "time": timeUTC,
        "list": list }

        //get database
        const db = firebaseApp.firestore()
        const userEmail = firebase.auth().currentUser.email
        db.collection('events').doc(userEmail).update({
            "events": firebase.firestore.FieldValue.arrayUnion(data)
        })
    };

    return(
        <>
        <button
            className="btnUnmark"
            onClick={()=> {handleUnmarkClickOpen(props.index);}}
        >
            Unmark &nbsp;<EmailIcon />
        </button>                                 
    
        <div>
            <Dialog
                open={ConfirmOpen}
                onClose={handleCmfClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                align = "center"
            >                                                    
                <DialogContent>
                    <DialogContentText className="alert-dialog-description">
                        Are you sure to <b><u>UNMARK</u></b><br />
                        <b><u>{props.email}</u></b><br />
                        this email from {list}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="dialogBtnSection">
                    <Button className="btnCmfUnmark" onClick={()=> {handleCmfClose();handleOkOpen();}}>
                        <b>Confirm</b>
                    </Button>
                    <Button className="btnCancel" onClick={handleCmfClose}>
                        <b>Cancel</b>
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={OkOpen}
                onClose={handleOkClose}
                align="center"
            >
                <DialogContent>
                    <DialogContentText className="alert-dialog-description">
                        Sender Email Address <br />
                        <b>({props.email})</b> <br /> 
                        has been unmark from {list}.
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="dialogBtnSection"> 
                    <Button className="btnOk" onClick={()=> {handleEvent(); handleOkClose();unmarkEmail(mail ,list );}}>
                        <b>Ok</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    </>
    );
}

function Logout(){
    return(
        <div className="btnLogout">
            <IconButton
            aria-label="exit icon"
            edge="start"
            href="/logout"
            >
                <div className="material-icons exitIcon">
                    exit_to_app
                </div>
            </IconButton>
        </div>
    );
}

function Copyright()
{
    return (
      <>
        {'Copyright © '}
        <Link to="https://isitphishy.wixsite.com/website" target="_blank">
            Phishy
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </>
    );
}
  
function EmailList() 
{
    return (
        <>
        <div className="topSectionBackground">
            <div className="topContentBackground">
              <DisplayHeaderContent />
              <MenuLink />
              <Logout />

          </div>
        </div>
        <div className="listTableSection">
            <GetEmailAddress />
        </div>
        <div className="footer">
            <Copyright />
        </div>
        </>
    )
}
export default EmailList;
